//CRN_20251218 - ⚠️ Avoid using this service prior to an R&D Team discussion ⚠️

import { ExceptionsService } from './utelize/general/exceptions-service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class PaginationService {
  private direction: any='asc';

  public pageSize  : any=8;
  public page      : any=1;
  public startIndex: number=1;
  public endIndex  : number=9;
  
  constructor(
    private exceptionsService: ExceptionsService
  ) { }
  
  public changePage(alldata: any[]): any[] {
    try {
      const startItem=(this.page-1) * this.pageSize+1;
      const endItem  =(this.page-1) * this.pageSize+this.pageSize;
      this.endIndex  =endItem;
      
      if (this.endIndex>alldata.length) {
        this.endIndex=alldata.length;
      }
      
      return alldata.slice(startItem-1, endItem);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }
  
  public onSort(column: any, dataList: any[]) {
    try {
      if (this.direction=='asc') {
        this.direction='desc';
      } else {
        this.direction='asc';
      }

      const sortedArray=[...dataList];
      
      sortedArray.sort((a, b) => {
        const res=this.compare(a[column], b[column]);
        
        return this.direction==='asc' ? res : -res;
      });
      
      return dataList=sortedArray;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private compare(v1: string | number, v2: string | number): number {
    try {
      return v1<v2 ? -1 : v1>v2 ? 1 : 0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 0;
    }
  }
}
